module.exports = __webpack_public_path__ + "20886759a1ad59a996c2ac0ac1a41010.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key_art-320.jpg
// module id = 440
// module chunks = 0